module.exports = __webpack_public_path__ + "images/avisbudget94072b02271d8b3c672be355bf48762f.png";